export { unstable_generateUtilityClass as default } from '@mui/utils';